import React from "react";
import "./windowPeak.css";
const WindowPeak = () => {
  return <div className="window-peak"></div>;
};

export default WindowPeak;
